import 'overlayscrollbars/overlayscrollbars.css';
import 'slim-select/styles';
import './ui-overrides.css';
import agentsText from '../AGENTS.md?raw';

import { createActor } from 'xstate';
import { dialogMachine } from './machines/dialogMachine';

import { renderMarkdown } from './app-helpers';
import { setupInfoDialogs } from './app-slider';
import { DComposeApp } from './app-core';
import { setupPanelHandles } from './app-panels';
import { setupAppActor } from './app-actor-wiring';
document.addEventListener('DOMContentLoaded', () => {
  if (parseInt(localStorage.getItem('gi_visualiser_h') ?? '0', 10) > window.innerHeight * 0.6) localStorage.removeItem('gi_visualiser_h');
  if (parseInt(localStorage.getItem('gi_pedals_h') ?? '0', 10) > window.innerHeight * 0.6) localStorage.removeItem('gi_pedals_h');
  setupPanelHandles();

  document.addEventListener('wheel', (e) => { if (e.ctrlKey) e.preventDefault(); }, { passive: false });
  document.addEventListener('gesturestart', (e) => { e.preventDefault(); });
  document.addEventListener('gesturechange', (e) => { e.preventDefault(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const actor = (window as unknown as { overlayActor?: { send: (e: { type: string }) => void; getSnapshot: () => { matches: (s: string) => boolean } } }).overlayActor;
      if (actor?.getSnapshot().matches('visible')) {
        actor.send({ type: 'CLOSE' });
      }
    }
  });
  const app = new DComposeApp();
  setupAppActor(app);

  const aboutBtn = document.getElementById('about-btn');
  const aboutDialog = document.getElementById('about-dialog');
  const aboutClose = document.getElementById('about-close');
  const aboutContentEl = document.getElementById('about-content');
  if (aboutDialog instanceof HTMLDialogElement) {
    const aboutRendered = renderMarkdown(agentsText);
    const aboutDialogActor = createActor(dialogMachine);
    aboutDialogActor.subscribe((snapshot) => {
      if (snapshot.matches('open')) {
        if (aboutContentEl) aboutContentEl.innerHTML = snapshot.context.content;
        aboutDialog.showModal();
      } else {
        aboutDialog.close();
      }
    });
    aboutDialogActor.start();

    aboutBtn?.addEventListener('click', () => {
      aboutDialogActor.send({ type: 'OPEN', content: aboutRendered });
    });
    aboutClose?.addEventListener('click', () => { aboutDialogActor.send({ type: 'CLOSE' }); });
    aboutDialog.addEventListener('click', (e) => {
      if (e.target === aboutDialog) aboutDialogActor.send({ type: 'CLOSE' });
    });
  }
  setupInfoDialogs();
});
